import { AController } from "@eagerlogic/react-mvc";
import { ApiException } from "rpc/rpc";
import { AuthRpc } from "rpc/auth/AuthRpc";
import { RegisterModel } from "../model/RegisterModel";

export class RegisterController extends AController<RegisterModel> {

    protected createInitialModel(): RegisterModel {
        var model = new RegisterModel();
        model.isInit = true;

        AuthRpc.timezones().then((res) => {
            this.model.isInit = false;
            this.model.timezoneItems = res.items;
            this.model.timeZone = this.pickDefaultTimeZone(res.items.map((i) => i.id));
            this.render(this.model);
        });

        return model;
    }

    public onRegisterClicked(companyName: string, userName: string, email: string, password: string, timeZone: string) {
        this.model.companyName = companyName;
        this.model.userName = userName;
        this.model.email = email;
        this.model.password = password;
        this.model.timeZone = timeZone;
        this.clearErrors();
        this.render(this.model);

        AuthRpc.register({
            companyName: companyName,
            userName: userName,
            email: email,
            password: password,
            timeZone: timeZone
        }).then(() => {
            window.location.href = "/index.rsc";
        }).catch((ex: ApiException) => {
            this.model.companyNameError = this.fieldError(ex, "companyName");
            this.model.userNameError = this.fieldError(ex, "userName");
            this.model.emailError = this.fieldError(ex, "email");
            this.model.passwordError = this.fieldError(ex, "password");
            if (ex != null && (ex.fieldErrors == null || Object.keys(ex.fieldErrors).length < 1) && ex.message != null) {
                this.model.error = ex.message;
            }
            this.render(this.model);
        });
    }

    public onCancelClicked() {
        window.location.href = "/index.jsp";
    }

    private pickDefaultTimeZone(ids: string[]): string {
        try {
            var browserTz = Intl.DateTimeFormat().resolvedOptions().timeZone;
            if (browserTz != null && ids.indexOf(browserTz) >= 0) {
                return browserTz;
            }
        } catch (e) {
            // ignore, fall back below
        }
        return ids.length > 0 ? ids[0] : "";
    }

    private clearErrors() {
        this.model.error = null;
        this.model.companyNameError = null;
        this.model.userNameError = null;
        this.model.emailError = null;
        this.model.passwordError = null;
    }

    private fieldError(ex: ApiException, field: string): string {
        if (ex != null && ex.fieldErrors != null && ex.fieldErrors[field] != null) {
            return ex.fieldErrors[field];
        }
        return null;
    }

}
